/* eslint-disable
    no-prototype-builtins,
*/

// Polyfill for ResizeObserver allowing use for old browsers and testing
if (typeof ResizeObserver === "undefined") {
  if (typeof window !== "undefined") {
    window.ResizeObserver = require("resize-observer-polyfill")
  } else {
    global.ResizeObserver = require("resize-observer-polyfill")
  }
}

import domready from "domready"

// Simple fallback for link rel='preload' (supports IE9+)
const preloadSupported = () => {
  try {
    return document.createElement("link").relList.supports("preload")
  } catch {
    return false
  }
}

if (!preloadSupported()) {
  domready(() => {
    document.querySelectorAll("link[rel='preload']").forEach((element) => {
      element.removeAttribute("onload")
      element.setAttribute("rel", "stylesheet")
    })
  })
}

// Add support to IE9+ for node.remove()
// see: https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
// from: https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
;(function (arr) {
  arr.forEach((item) => {
    if (Object.prototype.hasOwnProperty.call(item, "remove")) {
      return
    }
    Object.defineProperty(item, "remove", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null) {
          this.parentNode.removeChild(this)
        }
      },
    })
  })
})([Element.prototype, CharacterData.prototype, DocumentType.prototype])
